import React, { useEffect, useState, useRef } from "react";
import Header from "../../reusables/Header";
import MerchantTabs, { isBookingAddonEnabled } from "../../reusables/MerchantTabs";
import "./partials/modal/index.scss";
// import Footer from "../../reusables/Footer";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import {
  CHECK_IN,
  FETCH_MERCHANT_DETAILS,
  SIGNUP_USER,
  GET_CUSTOMER_POINT_DETAILS,
  FETCH_MERCHANT_BY_ID,
  GET_USERS_BY_PHONE,
} from "../../constants";
import "./index.scss";
import {
  Button,
  Col,
  message,
  Row,
  Card,
  Modal,
  Pagination,
  Tabs,
  Spin,
  Input,
  Select,
  Carousel,
  Image,
  Badge
} from "antd";
import { organ1 } from "../../assets/images";
import { SearchOutlined, SlidersOutlined, PicLeftOutlined } from "@ant-design/icons";
import { HiSparkles, HiArrowUpOnSquare, HiGift, HiPlus } from "react-icons/hi2";
import { Redirect, useHistory } from "react-router-dom";
import {
  HomePic6,
  LoveIcon,
  JayAutos,
  LogoBlack,
  addButton,
  AddBlack,
  ScrollToFind,
} from "../../assets/icons";
import LetterAvatar from "../../reusables/LetterAvatar";
import SigninModal from "../homepage/partials/SigninModal";
import { findCustomerByContact, provisionLoyaltyId } from "../../utilities/customerLoyaltyApi";
import Axios from "axios";
import { useDispatch, useSelector, connect } from "react-redux";
import {
  addToCart,
  clearCart,
  getMerchantByDispatch,
  reSignInSuccess,
  reSignInLoading,
} from "../../redux/actions/orders";
import Footer from "../../reusables/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
// import { Helmet } from 'react-helmet-async';
import {
  getApp,
  getMerchantApp,
  saveMerchantState,
  getProductBundle,
  getSingleCacheData
} from "../../redux/actions/merchant";
import { getUrewardsAuth } from "../../redux/actions/ussdActions";
import GiftModal from "./partials/modal/giftModal";
import VariantModal from "./partials/modal/variantModal";
import { BranchModal } from "./partials/modal/branchmodal";
import { setBranchAddress } from "../../redux/actions/branch";
import Booking from "../../features/booking/Booking";
import CustomQuantityModal from "./partials/modal/custQuantitymodal";
import { getMerchantLoyaltyProgram } from "../../redux/actions/productaction";
import PriceFilter from "./partials/modal/PriceChecker";
import { getCountryCode, saveCountryDetails } from "../../redux/actions/general";

const Option = Select.Option;
function MerchantsPage() {
  const [signInModalVisible, setSignInModalVisible] = useState(false);
  const [redirect, setRedirect] = useState(null);
  const [newUser, setNewUser] = useState(null);
  const [merchantProduct, setMerchantProduct] = useState([]);
  const [displayVariant, setDisplayVariant] = useState(false);
  const [productWithVariant, setproductWithVariant] = useState([]);
  const [variantQuantity, setVariantQuantity] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [askCart, setAskCart] = useState(false);
  const [confirmSignin, setConfirmSignIn] = useState(false);
  const [preventLoad, setPreventLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currrentPageNumber, setCurrentPageNumber] = useState(12);
  const [totalProductNum, setTotalProductNum] = useState(0);
  const [productsLoading, setProductsLoading] = useState(true); // Start with loading true
  const [checkDescription, setCheckDescription] = useState(false);
  const [description, setDescription] = useState({});
  const [source, setSource] = useState("");
  const [confirmGiftCard, setConfirmGiftCard] = useState(false);
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const [ openCustQuantity, setOpenCustQuantity ] = useState(false);
  const [productVariantModal, setProductVariantModal] = useState({});
  const [productCustomQuantityModal, setProductCustomQuantityModal] = useState(null);
  const [merchantLoad, setMerchantLoad] = useState(false);
  const [activeKey, setActiveKey] = useState("All");
  const [productCategory, setProductCategory] = useState([]);
  const [catName, setCatName] = useState([]);
  const [merchantProductFilter, setMerchantProductFilter] = useState([]);
  const [allMerchantProduct, setAllMerchantProduct] = useState([]);
  const [loadingAllProduct, setLoadingAllProduct] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openBranchModal, setOpenBranchModal] = useState(false);
  const [merchantBranches, setMerchantBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [isBranchSelected, setIsBranchSelected] = useState(false);
  const [ selectedBranchDetails, setSelectedBranchDetails ] = useState(null);
  const [showBranchSelect, setShowBranchSelect] = useState(false);
  const [ bundledProduct, setBundledProduct ] = useState([]);
  const [ merchantLoyaltyProgram, setMerchantLoyaltyProgram ] = useState([]);
  const [ isCredPalEnabled, setIsCredPalEnabled ] = useState(false);
  const [ openPriceFilter, setOpenPriceFilter ] = useState(false);
  const [ selectedVariants, setSelectedVariants ] = useState({});
  const [ minPrice, setMinPrice ] = useState(0);
  const [ maxPrice, setMaxPrice ] = useState(0);
  const [ currentMinPrice, setCurrentMinPrice ] = useState(0);
  const [ currentMaxPrice, setCurrentMaxPrice ] = useState(0);
  const [ keys1, setKeys1 ] = useState([]);
  const [ groupVariant, setGroupedVariant ] = useState({});


  const inputRef = useRef();
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname, search, state } = history.location;
  const isJoinFlow = pathname.includes('/join') || search.includes('join=true') || search.includes('program_id');
  const rawMerchantSlug = pathname.includes('/join') ? pathname.split('/join')[0] : pathname;
  const merchant_rewards_id = rawMerchantSlug.replace(/^\//, '').toLowerCase();
  const isNumericMerchantId = /^\d+$/.test(merchant_rewards_id);
  const merchant_id = state?.merchant_id;
  const targetMerchantId = merchant_id || (isNumericMerchantId ? merchant_rewards_id : null);
  const queryParams = new URLSearchParams(search);
  const passProgramId = queryParams.get('program_id');
  const passProgramName = queryParams.get('program_name') || '';
  const passMerchantName = queryParams.get('merchant_name') || queryParams.get('business_name') || '';
  const passLogoUrl = queryParams.get('logo_url') || '';
  const passHeroImageUrl = queryParams.get('hero_image_url') || queryParams.get('art_url') || '';
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [selectedProgramId, setSelectedProgramId] = useState(null);
  // Tracks whether the async loyalty_id lookup from the API has completed.
  // Wallet pass buttons must not render until this is true to avoid encoding
  // a stale/fallback ID (e.g. phone number) into the barcode.
  const [loyaltyIdResolved, setLoyaltyIdResolved] = useState(false);
  const identifier_string = search.slice(1);

  useEffect(() => {
    setMerchantLoyaltyProgram([]);
    setProductCategory([]);
    setAllMerchantProduct([]);
    setMerchantProduct([]);
    setMerchantProductFilter([]);
    setSelectedProgramId(null);
    setCustomerLoyaltyProgram(null);
    setPreventLoad(false);
    setIsServicesEnabled(false);
    try {
      localStorage.removeItem("merchant_app");
    } catch (e) {}
  }, [merchant_rewards_id, targetMerchantId]);
  const { carts, loading } = useSelector((state) => state.Order);
  const { merchantDetails: MerchantDetails } = useSelector(
    (state) => state.merchant
  );
  const [ customerLoyaltyProgram, setCustomerLoyaltyProgram ] = useState(null);
  const {
    success,
    loading: resignLoading,
    merchantIdArray,
  } = useSelector((state) => state.resign);
  const { productLoading, productSuccess, productsProduct } = useSelector(
    (state) => state.productState
  );
  const [getUserDetails] = useLazyQuery(GET_USERS_BY_PHONE);
  const {
    success: merchantsuccess,
    loading: merchantloading,
    merchanted,
  } = useSelector((state) => state.merchantState);
  const { uRewardsAuth, status, ussdOrderSuccess } = useSelector(
    (state) => state.urewardsAuth
  );

  const [isServicesEnabled, setIsServicesEnabled] = useState(false);
  const [isProductBundleEnabled, setIsProductBundleEnabled] = useState(false);

  useEffect(()=>{
    if (isProductBundleEnabled) {
      dispatch(getProductBundle())
      .then(resp=>{
        if (!isMountedRef.current) return;
        setBundledProduct(resp.data.products);
      })
      .catch(err=>console.log("e", err));
    }
  }, [isProductBundleEnabled]);

  useEffect(() => {
    // Reset resolution flag whenever the merchant context changes
    setLoyaltyIdResolved(false);

    // Safety fallback timer so wallet pass UI is never stuck in loading
    const safetyTimer = setTimeout(() => {
      if (isMountedRef.current) {
        setLoyaltyIdResolved(true);
      }
    }, 2500);

    const storageUser = localStorage.getItem("user_customer_details");
    const user = storageUser ? JSON.parse(storageUser) : null;
    if (user) {
      const activeMId = targetMerchantId || merchant_rewards_id || merchant_id || '37';
      const isSameMerchant = user.merchant_id && String(user.merchant_id) === String(activeMId);

      const initialLoyaltyId = (user.loyalty_id && String(user.loyalty_id).length >= 8 && !String(user.loyalty_id).startsWith('LOY-')) 
        ? String(user.loyalty_id) 
        : (user.loyaltyId && String(user.loyaltyId).length >= 8 && !String(user.loyaltyId).startsWith('LOY-') ? String(user.loyaltyId) : null);

      const cleanUser = {
        ...user,
        total_points: user.total_points || 0,
        total_stamps: user.total_stamps || 0,
        loyalty_id: initialLoyaltyId,
        merchant_id: activeMId
      };
      setNewUser(cleanUser);

      if ((user.phone_number || user.email) && activeMId) {
        // Fetch the authoritative loyalty_id from the API for this merchant.
        // The wallet pass URL must NOT be built until this resolves so that we
        // never encode a stale/fallback value (e.g. phone number) in the barcode.
        findCustomerByContact(activeMId, user.phone_number || user.email)
          .then(async (customerData) => {
            if (!isMountedRef.current) return;
            const activeCustomerId = customerData?.id || customerData?.customer_id || user.id || user.customer_id;
            let effectiveLoyaltyId = (customerData?.loyalty_id && String(customerData.loyalty_id).length >= 8 && !String(customerData.loyalty_id).startsWith('LOY-'))
              ? String(customerData.loyalty_id)
              : null;

            if (!effectiveLoyaltyId && activeCustomerId && activeMId) {
              try {
                const provisionedId = await provisionLoyaltyId(activeMId, activeCustomerId);
                if (provisionedId && String(provisionedId).length >= 8) {
                  effectiveLoyaltyId = String(provisionedId);
                }
              } catch (e) {
                console.error("Loyalty provision error:", e);
              }
            }

            if (!isMountedRef.current) return;
            if (effectiveLoyaltyId) {
              const updatedUser = {
                ...cleanUser,
                id: activeCustomerId,
                customer_id: activeCustomerId,
                loyalty_id: effectiveLoyaltyId,
                total_points: customerData?.total_points || 0,
                total_stamps: customerData?.total_stamps || 0,
                merchant_id: activeMId
              };
              setNewUser(updatedUser);
              localStorage.setItem("user_customer_details", JSON.stringify(updatedUser));
            }
          })
          .catch((err) => {
            console.log("Customer lookup for merchant:", err?.message || err);
          })
          .finally(() => {
            if (isMountedRef.current) {
              setLoyaltyIdResolved(true);
            }
          });
      } else {
        // No contact details to look up — resolve immediately
        if (isMountedRef.current) setLoyaltyIdResolved(true);
      }
    } else {
      // No logged-in user — resolve immediately
      if (isMountedRef.current) setLoyaltyIdResolved(true);
    }
    return () => clearTimeout(safetyTimer);
  }, [merchant_rewards_id, targetMerchantId]);

  useEffect(() => {
    if (newUser) {
      localStorage.setItem("user_customer_details", JSON.stringify(newUser));
    }
  }, [newUser]);

  // useEffect(()=>{
  // 	dispatch(getMerchantApp());
  //   }, []);
  // useEffect(() => {
  // 	if (!merchant_id) {
  // 		setRedirect("/404");
  // 	}

  // }, [merchant_rewards_id, merchant_id]);

  useEffect(() => {
    if (merchanted?.payout_active === true) {
      const email = merchanted.email;
      // dispatch(getUrewardsAuth({ email }));
    }
  }, [merchanted]);

  // useEffect(() => {
  // 	const storageUser = localStorage.getItem("user_customer_details");
  // 	!newUser &&
  // 		!storageUser &&
  // 		setTimeout(() => {
  // 			message.warn("sign in to continue")
  // 			setSignInModalVisible(true);
  // 		}, 5000);
  // }, [newUser]);

  //saving location to state
  useEffect(() => {
    const merchantUrl = history.location.pathname + history.location?.search;
    localStorage.setItem("urewards_merchant_url", JSON.stringify(merchantUrl));
  }, [history]);

  useEffect(() => {
    const body = document.querySelector("body");
    body.style.background = "#000";
  }, []);

  useEffect(() => {
    handleGetCurrentLocation();
  }, [])

  const handleOpenVariant = (product) => {
    const storageUser = localStorage.getItem("user_customer_details");
    const user = storageUser ? JSON.parse(storageUser) : null;
    if (!user) {
      message.error("Sign in to add products to your cart");
      return setSignInModalVisible(true);
    }

    const merchantDetails = JSON.parse(
      localStorage.getItem("merchant_details")
    );

    const cart_items = JSON.parse(localStorage.getItem("urewards-carts"));

    const new_cart =
      cart_items &&
      cart_items.find((items) => {
        return items.merchant_id !== merchantDetails.id;
      });

    if (new_cart) {
      toast.warning(`Check out from previous merchant to proceed to cart`, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setAskCart(true);
      return;
    }

    setProductVariantModal(product);
    setOpenVariantModal(true);
  };

  const handleGetCurrentLocation = () => {
    getCountryCode()
    .then(res => {
      if(res.status === 200){
        dispatch(saveCountryDetails(res.data));
      }
    })
    .catch(err => {
      console.log("err", err);
      
    })
  }

  const handleSignIn = (merchant) => {
    const isUser = localStorage.getItem("user_customer_details");
    if(!isUser) return;
    const user = JSON.parse(isUser);
    const phone_number = user.phone_number;
    

    // let userPhone = phone_number.includes("+") ? phone_number : "+"+phone_number
		
		getUserDetails({ 
			variables: { 
			  phone_number: phone_number,
        merchant_id: merchant
			}, 
			onCompleted: (data) => {
				if (!isMountedRef.current) return;
				const { message: mess, user } = data.getUserByPhone;

        if(mess === "failed, user does not exist!"){
          return handleSignUp(user)
        }
        
				if(user){
          const storageuser = localStorage.getItem("user_customer_details");
          const newUser = JSON.parse(storageuser)
          newUser.user_id = user.user_id;
          localStorage.setItem("user_customer_details", JSON.stringify(newUser));
          setNewUser(user);
          setCustomerLoyaltyProgram(user.loyalty_points)
          !!checkInAgain && checkInAgain();
        }
			}
		});
	}

  const displayVariants = (product) => {
    if(product.variants.length === 0) return;
    const groupedVariants = {};
    const selectVariantsObj = {};

    product?.variants?.map(variant => {
        if (groupedVariants[variant.type]) {
            groupedVariants[variant.type].push(variant);
        } else {
            selectVariantsObj[variant.type] = [];
            groupedVariants[variant.type] = [variant];
        }
    });

    return <div className="variants"><div className='oi'>
      {Object.keys(groupedVariants) && Object.keys(groupedVariants).map((keyo, index)=>{
        return <div key={index}>
        <span className="type" key={index}>{`${keyo}:`}</span>
        <div className="variant-wrapper">
        {groupedVariants && groupedVariants[keyo]?.map((variant, index) => {
          return (
            <div  style={{display: "flex", flexDirection: "column-reverse", alignItems: "center", gap:0}} key={index}>
               <Badge
                  key={index}
                  className={
                  "variant"
                  }
                  onClick={() => {
                    addProductToCartVariant(product, variant)
                  }}
              >
                <span style={{ paddingRight: "10px" }}>{variant.value}</span>
                <span style={{ paddingRight: "10px" }}>-</span>
                <span>
                  {merchant.currency}
                  {product.tax_rate
                    ? (
                        (product.tax_rate / 100) * variant.price +
                        parseFloat(variant.price)
                      ).toFixed(2)
                    : variant.price}
                </span>
              </Badge>
              {variant.picture && <div>
                  {<Image 
                    src={variant.picture}
                    alt={variant.value}
                    style={{width: 70, height:70}}
                  />}
                </div>}
            </div>
          );
        })}
      </div></div>
      })}
    </div></div>
  };

  const addProductToCartVariant = (produce, variant) => {
    const itemC = localStorage.getItem("urewards-carts");
    const carts = itemC ? JSON.parse(itemC) : [];
    const totalProductCount = variant.quantity;
    let product = {...produce}
    product.variants = [variant];
    // let 
    const qty = 1;

		if(Number(variant.quantity) <= 1 ){
			toast.warning(`${variant.value} is out of stock`, {
				position: "top-center",
				autoClose: 2000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
			   });
			return;
		}

		const basket = document.querySelector("#cartBasket");
		basket.classList.add("cart_animate");
		setTimeout(() => {
			basket.classList.remove("cart_animate")
		}, 700);
	
		const ifProductIsAdded = carts.filter((item)=>{
			return item.id === product.id;
		});
		
		if( ifProductIsAdded.length !== 0 ){
      const isSameItemVariantPresent = ifProductIsAdded.filter((item)=>{
        return item.variants[0].id === variant.id;
      });

      if(isSameItemVariantPresent.length !== 0){
        const quantity = isSameItemVariantPresent[0].quantity + 1 ;
        if(product.track_inventory){
          if(quantity > Number(variant.quantity)){
            toast.warning(`${variant.value} is out of stock`, {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
              });
            return;
          }
        }
        
        dispatch( addToCart( {product, quantity, totalProductCount, variant} ) );
        toast.success(`Successfully added ${variant ? variant.value : "Item"} to Cart`, {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // onCancel();
        
      }else{
        const quantity = qty;
        dispatch( addToCart( {product, quantity, totalProductCount, variant} ) );

        toast.success(`Successfully added ${variant ? variant.value : "Item"} to Cart`, {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // onCancel();
      }
			
		}else{
			const quantity = qty;
			dispatch( addToCart( {product, quantity, totalProductCount, variant} ) );

			toast.success(`Successfully added ${variant ? variant.value : "Item"} to Cart`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
        });
        // onCancel();
		}

	};

  const handleSelectCustomQuantity = (product) => {
    const storageUser = localStorage.getItem("user_customer_details");
    const user = storageUser ? JSON.parse(storageUser) : null;
    if (!user) {
      message.error("Sign in to add products to your cart");
      return setSignInModalVisible(true);
    }

    const merchantDetails = JSON.parse(
      localStorage.getItem("merchant_details")
    );

    const cart_items = JSON.parse(localStorage.getItem("urewards-carts"));

    const new_cart =
      cart_items &&
      cart_items.find((items) => {
        return items.merchant_id !== merchantDetails.id;
      });

    if (new_cart) {
      toast.warning(`Check out from previous merchant to proceed to cart`, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setAskCart(true);
      return;
    }

    setProductCustomQuantityModal(product);
    setOpenCustQuantity(true);
  }

  const [signUpUser] = useMutation(SIGNUP_USER, {
    onCompleted: (data) => {
      if (!isMountedRef.current) return;
      if (data?.signUpUser) {
        setNewUser(data.signUpUser);
      }
      const activeMId = targetMerchantId || merchantDetails?.merchant_details?.id;
      if (activeMId) {
        dispatch(reSignInSuccess(activeMId));
      }
    },
    onError: (error) => {
      console.log("Signup:", error.message);
    },
  });

  const getCustomerByPhone = (phone_num) => {
    Axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v2/get_urewards_customer?phone=${phone_num}`
    )
      .then((res) => {
        if (!isMountedRef.current) return;
        if (res.status === 200) {
          setNewUser(res.data);
        }
      })
      .catch((err) => {
        if (!isMountedRef.current) return;
        message.error(err.response?.data.message || err.message);
      });
  };

  const getMerchantProgram = (email) => {
    getMerchantLoyaltyProgram(email)
    .then((res) => {
      if (!isMountedRef.current) return;
      const rawPrograms = res?.loyalty_program || [];
      const activePrograms = (Array.isArray(rawPrograms) ? rawPrograms : []).filter(
        (p) => p && (p.active === true || p.active === 1 || p.active === "1" || p.status === true || p.status === "1" || String(p.status).toLowerCase() === "active") && !p.deleted
      );
      setMerchantLoyaltyProgram(activePrograms);
    })
    .catch(err=>console.log(err));

  }

  const getCustomerPoint = (program_name) => {
    if(!customerLoyaltyProgram) return 0;

    let programs = [];

    if(customerLoyaltyProgram && customerLoyaltyProgram.simple_points) {
      programs.push(...customerLoyaltyProgram["simple_points"])
    }

    if(customerLoyaltyProgram && customerLoyaltyProgram.stamps_program) {
      programs.push(...customerLoyaltyProgram["stamps_program"])
    }
    if(programs.length === 0) return 0
    const isProgramFound = programs.find(program => program.program_name === program_name);

    if(isProgramFound) {
      const val = isProgramFound?.accumulated_points != null ? isProgramFound.accumulated_points : isProgramFound.accumulated_stamps;
      return val != null ? Math.floor(Number(val)) || 0 : 0;
    }

    return 0;
  }

  const onSlidderChange = (min, max) =>{
      setCurrentMinPrice(min);
      setCurrentMaxPrice(max);
  }

  const calculateMinPrice = (products) => {
    if (!products || products.length === 0) return 0;
    
    const prices = products
      .filter(prod => prod.price && !isNaN(Number(prod.price)))
      .map(prod => Number(prod.price));
    
    if (prices.length === 0) return 0;
    
    return Math.min(...prices);
  }

  const calculateMaxPrice = (products) => {
    if (!products || products.length === 0) return 1000000;
    
    const prices = products
      .filter(prod => prod.price && !isNaN(Number(prod.price)))
      .map(prod => Number(prod.price));
    
    if (prices.length === 0) return 1000000;
    
    return Math.max(...prices);
  }

  const getAvailableVariants = (products) => {
    if (!products || products.length === 0) return {};
    
    const variantsByType = {};
    
    products.forEach(product => {
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach(variant => {
          if (variant.type && variant.value && variant.type.trim() !== '' && variant.value.trim() !== '') {
            const type = variant.type.trim();
            const value = variant.value.trim();
            
            if (!variantsByType[type]) {
              variantsByType[type] = new Set();
            }
            variantsByType[type].add(value);
          }
        });
      }
    });
    
    // Convert Sets to sorted arrays
    const result = {};
    Object.keys(variantsByType).forEach(type => {
      result[type] = Array.from(variantsByType[type]).sort();
    });
    
    return result;
  }

  const handleApplyPriceFilter = () =>{
    let filteredProducts = allMerchantProduct.filter((prod) => {
      return currentMinPrice <= Number(prod.price) && Number(prod.price) <= currentMaxPrice;
    });

    // Apply variant filters if any variants are selected
    const selectedVariantTypes = Object.keys(selectedVariants);
    if (selectedVariantTypes.length > 0) {
      filteredProducts = filteredProducts.filter((prod) => {
        if (!prod.variants || prod.variants.length === 0) return false;
        
        // Check if product has all selected variant types with matching values
        return selectedVariantTypes.every(variantType => {
          const selectedValue = selectedVariants[variantType];
          if (!selectedValue) return true; // Skip if no value selected for this type
          
          return prod.variants.some(variant => 
            variant.type === variantType && variant.value === selectedValue
          );
        });
      });
    }

    const pageSize = currrentPageNumber || 12;
    setMerchantProduct(filteredProducts.slice(0, pageSize));
    setMerchantProductFilter(filteredProducts);
    setTotalProductNum(Number(filteredProducts.length));
    setCurrentPage(1);
    setOpenPriceFilter(false);
  };

  const onVariantChange = (type, value) => {
    setSelectedVariants(prev => ({
      ...prev,
      [type]: value
    }));
  }

  const resetFilter = () => {
    setCurrentPage(1);
    setActiveKey("All");
    if (allMerchantProduct && allMerchantProduct.length > 0) {
      const pageSize = currrentPageNumber || 12;
      setMerchantProduct(allMerchantProduct.slice(0, pageSize));
      setMerchantProductFilter(allMerchantProduct);
      setTotalProductNum(allMerchantProduct.length);
    } else {
      getMerchantProduction(1, 12);
    }
    // Reset minimum and maximum price to the calculated values from all products
    const minProductPrice = calculateMinPrice(allMerchantProduct);
    const maxProductPrice = calculateMaxPrice(allMerchantProduct);
    setMinPrice(minProductPrice);
    setMaxPrice(maxProductPrice);
    setCurrentMinPrice(minProductPrice);
    setCurrentMaxPrice(maxProductPrice);
    setSelectedVariants({});
    setOpenPriceFilter(false);
  }


  useEffect(() => {
    newUser?.phone_number && getCustomerByPhone(newUser.phone_number);
  }, []);

  // Update minimum and maximum price when allMerchantProduct changes
  useEffect(() => {
    if (allMerchantProduct.length > 0) {
      const minProductPrice = calculateMinPrice(allMerchantProduct);
      const maxProductPrice = calculateMaxPrice(allMerchantProduct);
      setMinPrice(minProductPrice);
      setMaxPrice(maxProductPrice);
      setCurrentMinPrice(minProductPrice);
      setCurrentMaxPrice(maxProductPrice);
    }
  }, [allMerchantProduct]);

  const handleVariantChoice = (item) => {
    setVariantQuantity(item.quantity);
  };

  const handleVariantAdd = () => {
    if (variantQuantity === null) {
      message.warn("Click variant to purchase");
      return;
    }
    if (quantity >= variantQuantity) {
      message.warn("Item cannot exceed this quantity");
      return;
    }
    setQuantity(quantity + 1);
  };

  const handleVariantRemove = () => {
    if (quantity <= 1) {
      return;
    }
    setQuantity(quantity - 1);
  };

  const handleVariantDisplay = (product) => {
    setproductWithVariant(product);
    setDisplayVariant(true);
  };

  const handleCancelOrder = () => {
    dispatch(clearCart());
    setAskCart(false);
  };

  const addProductToCart = (product, qty, totalProductCount) => {
    // console.log("yes it has", product, qty, totalProductCount);
    const storageUser = localStorage.getItem("user_customer_details");
    const user = storageUser ? JSON.parse(storageUser) : null;
    if (!user) {
      message.error("Sign in to add products to your cart");
      return setSignInModalVisible(true);
    }
    const { products } = product;
    if(products && products.length > 0) product.bundle_id = product.id;

    // if (bundle_products.length > 0) product.bundle_id = product.id;

    if (product.quantity === "0.0" || product.quantity === "0") {
      toast.warning(`${product.name} is out of stock`, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }
    if (product.price === "0.0" || product.price === "0") {
      toast.warning(`${product.name} is out of stock`, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }
    // console.log( "test",product);
    // if(product.variants.length !== 0){
    // 	//
    // 	handleVariantDisplay(product);
    // 	return;
    // }
    // if(!qty) quantity=1
    const basket = document.querySelector("#cartBasket");
    basket.classList.add("cart_animate");
    setTimeout(() => {
      basket.classList.remove("cart_animate");
    }, 700);
    const merchantDetails = JSON.parse(
      localStorage.getItem("merchant_details")
    );
    const cart_items = JSON.parse(localStorage.getItem("urewards-carts"));

    const new_cart =
      cart_items &&
      cart_items.find((items) => {
        return items.merchant_id !== merchantDetails.id;
      });

    if (new_cart) {
      toast.warning(`Check out from previous merchant to proceed to cart`, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setAskCart(true);
      return;
    }
    const ifProductIsAdded = carts.find((item) => {
      return item.id === product.id;
    });

    if (ifProductIsAdded) {
      const quantity = ifProductIsAdded.quantity + 1;
      if (product.track_inventory) {
        if (quantity > Number(totalProductCount)) {
          toast.warning(`${product.name} is out of stock`, {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          return;
        }
      }
      dispatch(addToCart({ product, quantity, totalProductCount }));
      toast.success(
        `Successfully added ${product ? product.name : "Item"} to Cart`,
        {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        }
      );
    } else {
      const quantity = qty;
      dispatch(addToCart({ product, quantity, totalProductCount }));

      toast.success(
        `Successfully added ${product ? product.name : "Item"} to Cart`,
        {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        }
      );
    }
  };

  // useEffect(() => {
  // 	const detail = JSON.parse(localStorage.getItem("user_customer_details"));
  // 	if (detail?.merchant_id !== merchant?.id || detail?.merchant_id === null) {
  // 		handleSignUp();
  // 		console.log("true");
  // 	}
  // }, []);

  // Service booking
  const [serviceBooking, setServiceBooking] = useState(false);

  const { data: checkIn, refetch } = useQuery(
    CHECK_IN,
    {
      variables: { id: String(newUser?.user_id), identifier_string },
    },
    {
      onError: (error) => {
        message.error(error.message);
      },
    }
  );

  const checkInAgain = () => {
    refetch({ id: String(newUser?.user_id), identifier_string });
  };

  const [getMerchantPoints, { data: getCustomerPointDetails }] = useLazyQuery(
    GET_CUSTOMER_POINT_DETAILS,
    {
      variables: { customer_id: Number(newUser?.user_id) },
      // skip: !newUser?.user_id,
    },
    {
      onError: (error) => {
        message.error(error.message);
      },
    }
  );

  const totalCustomerPoints = getCustomerPointDetails?.getCustomerPointDetails
    ? Math.floor(
        getCustomerPointDetails.getCustomerPointDetails
          .map((point) => Number(point.points_value))
          .reduce((a, b) => a + b, 0)
      )
    : 0;

  useEffect(() => {
    if (totalCustomerPoints) {
      localStorage.setItem(
        "total_customer_point",
        JSON.stringify(totalCustomerPoints)
      );
    }
  }, [totalCustomerPoints]);

  useEffect(() => {
    checkInAgain();
    if(newUser) getMerchantPoints();
  }, [identifier_string, newUser?.user_id]);

  useEffect(() => {
    if (isJoinFlow) {
      const storageUser = localStorage.getItem("user_customer_details");
      if (!storageUser && !newUser) {
        setSignInModalVisible(true);
      } else if (newUser) {
        setShowWalletModal(true);
      }
    }
  }, [isJoinFlow, newUser]);

  // console.log({ checkIn });

  const { data: merchantDetailsData, loading: merchantDetailsLoading } =
    useQuery(
      FETCH_MERCHANT_DETAILS,
      {
        variables: { uRewardsId: merchant_rewards_id },
        skip: !!targetMerchantId,
        onCompleted: (data) => {
          if (!isMountedRef.current) return;
          if (!data?.fetchMerchantDetails || data.fetchMerchantDetails === "Merchant not found") return;
          const merchanDet = JSON.parse(data.fetchMerchantDetails);

          const branches = merchanDet.branches || [];

          setMerchantBranches(branches);

          if (branches.length > 0) {
            const homeBranchArr = branches.filter((branch) => {
              return branch.name.toLowerCase().includes("home");
            });
            const defaultBranch = homeBranchArr.length > 0 ? homeBranchArr[0] : branches[0];

            const branchpayload = {
              isbranchSet: true,
              address_line1: defaultBranch.address_line1,
              address_line2: defaultBranch.address_line2,
              branch_id: defaultBranch.id,
              branch_name: defaultBranch.name,
              latitude: defaultBranch.latitude,
              longitude: defaultBranch.longitude,
              state: defaultBranch.state
            };

            localStorage.setItem("homebranch", JSON.stringify(homeBranchArr));
            localStorage.setItem("allBranchDetails", JSON.stringify(branches));
            const isBranchSet = localStorage.getItem("branchdetails");
            handleSignIn(merchanDet.merchant_details.id);

            dispatch(getMerchantApp());
            getMerchantProgram(merchanDet.merchant_details.email);

            if (isBranchSet) {
              const setbranch = JSON.parse(isBranchSet);
              const doesBranchExist = branches.filter(branch => branch.name === setbranch.branch_name && branch.id === setbranch.branch_id);
              if (doesBranchExist.length > 0) {
                setSelectedBranchId(doesBranchExist[0].id);
                setIsBranchSelected(true);
                setSelectedBranchDetails(doesBranchExist[0]);
                dispatch(setBranchAddress(doesBranchExist[0]));
                localStorage.setItem("branchdetails", JSON.stringify(doesBranchExist[0]));
              } else {
                setSelectedBranchId(branches[0].id);
                setIsBranchSelected(true);
                setSelectedBranchDetails(branches[0]);
                dispatch(setBranchAddress(branches[0]));
                localStorage.setItem("branchdetails", JSON.stringify(branches[0]));
                if (branches.length > 1) setOpenBranchModal(true);
              }
            } else {
              setSelectedBranchId(defaultBranch.id);
              setIsBranchSelected(true);
              setSelectedBranchDetails(defaultBranch);
              localStorage.setItem("branchdetails", JSON.stringify(branchpayload));
              dispatch(setBranchAddress(branchpayload));
              if (branches.length > 1) setOpenBranchModal(true);
            }
          }
        },
      },
      {
        onError: (error) => {
          message.error(error.message);
        },
      }
    );

  const { data: merchantDetailsByIdData, loading: merchantDetailsByIdLoading } =
    useQuery(
      FETCH_MERCHANT_BY_ID,
      {
        variables: { merchant_id: String(targetMerchantId) },
        skip: !targetMerchantId,
        onCompleted: (data) => {
          if (!isMountedRef.current) return;
          if (!data?.fetchMerchantById || data.fetchMerchantById === "Merchant not found") return;
          const merchanDet = JSON.parse(data.fetchMerchantById);
          const branches = merchanDet.branches || [];
          setMerchantBranches(branches);
          if (branches.length > 0) {
            const defaultBranch = branches.find(b => b.name.toLowerCase().includes("home")) || branches[0];
            setSelectedBranchId(defaultBranch.id);
            setIsBranchSelected(true);
            setSelectedBranchDetails(defaultBranch);
          }
          handleSignIn(merchanDet.merchant_details.id);
          dispatch(getMerchantApp());
          getMerchantProgram(merchanDet.merchant_details.email);
        }
      },
      {
        onError: (error) => {
          message.error(error.message);
        },
      }
    );

  //get_product_by_id?product_id=id product with zer0 price, only display products that belongs to a branch alone. disable add and substract button, remove and fecting products by id and field from cart.
  const getMerchantDetails = (string) => {
    if (!string) return null;
    try {
      const merchant =
        string !== "Merchant not found" ? JSON.parse(string) : null;
      return merchant;
    } catch (error) {
      return error;
    }
  };

  const merchantDetails =
    getMerchantDetails(
      merchantDetailsData?.fetchMerchantDetails ||
        merchantDetailsByIdData?.fetchMerchantById
    ) || null;
  const merchantProducts =
    (merchantDetails &&
      merchantDetails.all_merchant_product?.messages[0].attachment?.payload
        .elements) ||
    [];

  const getMerchantProduction = (page = 1, pageNum = 12) => {
    if (!merchantDetails?.merchant_details?.id) return;
    
    setProductsLoading(true);
    const merchantId = merchantDetails.merchant_details.id;
    
    // If we have all products loaded, use client-side pagination
    if (allMerchantProduct && allMerchantProduct.length > 0) {
      const startIndex = (page - 1) * pageNum;
      const endIndex = startIndex + pageNum;
      const sourceList = (merchantProductFilter && merchantProductFilter.length > 0) ? merchantProductFilter : allMerchantProduct;
      const paginatedProducts = sourceList.slice(startIndex, endIndex);
      
      setMerchantProduct(paginatedProducts);
      setTotalProductNum(sourceList.length);
      setProductsLoading(false);
      return;
    }
    
    // Fallback to API for initial page load before getAllMerchantProduct completes
    Axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v2/get_products_of_merchant_urewards?merchant_id=${merchantId}&page[number]=${page}&page[size]=${pageNum}&page=${page}&per_page=${pageNum}&publish_to_loystar_shop=true`
    )
      .then((res) => {
        if (!isMountedRef.current) return;
        if (res.status === 200) {
          const filteredProducts = res.data.filter((prod) => {
            return prod.publish_to_loystar_shop === true;
          });
          setMerchantProduct(filteredProducts);
          setMerchantProductFilter(filteredProducts);

          const rawHeaderTotal =
            res.headers?.["total-count"] ||
            res.headers?.["total"] ||
            res.headers?.["Total-Count"] ||
            res.headers?.["Total"];
          const headerTotal = rawHeaderTotal ? parseInt(rawHeaderTotal, 10) : NaN;

          if (!isNaN(headerTotal) && headerTotal >= 0) {
            setTotalProductNum(headerTotal);
          } else if (allMerchantProduct && allMerchantProduct.length > 0) {
            setTotalProductNum(allMerchantProduct.length);
          } else {
            setTotalProductNum(filteredProducts.length);
          }
          setProductsLoading(false);
          setPreventLoad(true);
        }
      })
      .catch((err) => {
        if (!isMountedRef.current) return;
        setProductsLoading(false);
        message.error(err.response?.data?.message || err.message);
      });
  };

  const getAllMerchantProduct = async (page = 1, pageNum = 1000) => {
    if (!merchantDetails?.merchant_details?.id) return;
    
    setLoadingAllProduct(true);
    let allProducts = [];
    let currentPageNum = page;
    let hasMoreData = true;
    let totalRawFetched = 0;
    const merchantId = merchantDetails.merchant_details.id;
    
    try {
      while (hasMoreData && currentPageNum <= 100) {
        if (!isMountedRef.current) return;
        // Always use the general API to get ALL merchant products
        // This ensures no products are missed regardless of branch assignment
        const response = await Axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v2/get_products_of_merchant_urewards?merchant_id=${merchantId}&page[number]=${currentPageNum}&page[size]=${pageNum}&page=${currentPageNum}&per_page=${pageNum}&publish_to_loystar_shop=true`
        );
        if (!isMountedRef.current) return;
        
        if (response.status === 200 && response.data && response.data.length > 0) {
          totalRawFetched += response.data.length;
          const pageProducts = response.data.filter((prod) => {
            return prod.publish_to_loystar_shop === true;
          });
          
          allProducts = [...allProducts, ...pageProducts];
          
          const rawHeaderTotal =
            response.headers?.["total-count"] ||
            response.headers?.["total"] ||
            response.headers?.["Total-Count"] ||
            response.headers?.["Total"];
          const headerTotal = rawHeaderTotal ? parseInt(rawHeaderTotal, 10) : NaN;

          // Set total from header on first batch so pagination knows the count immediately
          if (currentPageNum === page && !isNaN(headerTotal) && headerTotal > 0 && (!totalProductNum || totalProductNum <= 12)) {
            setTotalProductNum(headerTotal);
          }

          if (!isNaN(headerTotal) && headerTotal > 0) {
            if (totalRawFetched >= headerTotal) {
              hasMoreData = false;
            } else {
              currentPageNum++;
            }
          } else if (response.headers?.["link"]) {
            const hasNextLink = response.headers["link"].includes('rel="next"');
            if (!hasNextLink) {
              hasMoreData = false;
            } else {
              currentPageNum++;
            }
          } else {
            const batchLimit = Math.min(pageNum, 100);
            if (response.data.length < batchLimit) {
              hasMoreData = false;
            } else {
              currentPageNum++;
            }
          }
        } else {
          hasMoreData = false;
        }
      }
      
      if (!isMountedRef.current) return;
      setLoadingAllProduct(false);
      setAllMerchantProduct(allProducts);
      // Set the minimum and maximum price based on the lowest and highest priced products
      const minProductPrice = calculateMinPrice(allProducts);
      const maxProductPrice = calculateMaxPrice(allProducts);
      setMinPrice(minProductPrice);
      setMaxPrice(maxProductPrice);
      setCurrentMinPrice(minProductPrice);
      setCurrentMaxPrice(maxProductPrice);

      // Seamlessly update current view if no active search
      if (!searchText || searchText.trim() === "") {
        if (activeKey === "All") {
          setTotalProductNum(allProducts.length);
          setMerchantProductFilter(allProducts);
          const startIndex = (currentPage - 1) * currrentPageNumber;
          setMerchantProduct(allProducts.slice(startIndex, startIndex + currrentPageNumber));
        } else if (activeKey === "Bundles") {
          const bundles = bundledProduct || [];
          setTotalProductNum(bundles.length);
          setMerchantProductFilter(bundles);
        } else if (catName[activeKey]) {
          const catProducts = allProducts.filter(p => p.merchant_product_category_id === catName[activeKey]);
          setTotalProductNum(catProducts.length);
          setMerchantProductFilter(catProducts);
          const startIndex = (currentPage - 1) * currrentPageNumber;
          setMerchantProduct(catProducts.slice(startIndex, startIndex + currrentPageNumber));
        }
      }
      
    } catch (err) {
      if (!isMountedRef.current) return;
      setLoadingAllProduct(false);
      message.error(err.response?.data?.message || err.message);
    }
  };

  const getProductCategory = () => {
    const merchant_email = merchantDetails?.merchant_details?.email;
    const mId = merchantDetails?.merchant_details?.id || targetMerchantId;
    if (!merchant_email && !mId) return;
    Axios.post(
      `${process.env.REACT_APP_MULTI_LEVEL_BASE_URL}/get_merchant_category`,
      { merchant_email, id: mId }
    )
      .then((res) => {
        if (!isMountedRef.current) return;
        if (res.status === 200 && res.data?.data) {
          setProductCategory(res.data.data);
        }
      })
      .catch((err) => {
        if (!isMountedRef.current) return;
        console.warn("Could not fetch product categories:", err?.response?.statusText || err.message);
      });
  };

  useEffect(() => {
    if (merchantDetailsData?.fetchMerchantDetails === "Merchant not found") return;
    setCurrentPage(1);
    setCurrentPageNumber(12);
    if (
      !merchantDetailsLoading &&
      !merchantDetailsByIdLoading &&
      isBranchSelected &&
      selectedBranchId
    ) {
      dispatch(getMerchantApp());
      getMerchantProduction(1, 12);
      getAllMerchantProduct();
      getProductCategory();
    } else if (
      !merchantDetailsLoading &&
      !merchantDetailsByIdLoading &&
      !isBranchSelected
    ) {
      dispatch(getMerchantApp());
      getMerchantProduction(1, 12);
      getAllMerchantProduct();
      getProductCategory();
    }
  }, [selectedBranchId, isBranchSelected]);

  // Initial loading effect when merchant details are available
  useEffect(() => {
    if (merchantDetails && merchantDetails.merchant_details) {
      getMerchantProduction(1, 12);
      getAllMerchantProduct();
      getProductCategory();
    }
  }, [merchantDetails?.merchant_details?.id]);

  // Populate branches from merchantDetails — covers both FETCH_MERCHANT_DETAILS
  // and FETCH_MERCHANT_BY_ID paths since merchantBranches may only be set in
  // the FETCH_MERCHANT_DETAILS onCompleted callback.
  useEffect(() => {
    const branches = merchantDetails?.merchant_details?.business_branches;
    if (!branches || branches.length === 0) return;

    if (merchantBranches.length === 0) {
      setMerchantBranches(branches);
    }

    // Auto-select branch if none has been chosen yet
    if (!selectedBranchId) {
      const stored = localStorage.getItem("branchdetails");
      if (stored) {
        const storedBranch = JSON.parse(stored);
        const match = branches.find(b => b.id === storedBranch.branch_id);
        if (match) {
          setSelectedBranchId(match.id);
          setIsBranchSelected(true);
          setSelectedBranchDetails(match);
          return;
        }
      }
      // Fall back to home/first branch
      const homeBranch = branches.find(b => b.name.toLowerCase().includes("home")) || branches[0];
      setSelectedBranchId(homeBranch.id);
      setIsBranchSelected(true);
      setSelectedBranchDetails(homeBranch);
      const payload = {
        isbranchSet: true,
        address_line1: homeBranch.address_line1,
        address_line2: homeBranch.address_line2,
        branch_id: homeBranch.id,
        branch_name: homeBranch.name,
        latitude: homeBranch.latitude,
        longitude: homeBranch.longitude,
      };
      localStorage.setItem("branchdetails", JSON.stringify(payload));
      dispatch(setBranchAddress(payload));
    }
  }, [merchantDetails?.merchant_details?.id]);

  // Ensure products are loaded when allMerchantProduct is populated
  useEffect(() => {
    if (allMerchantProduct && allMerchantProduct.length > 0 && merchantProduct.length === 0) {
      getMerchantProduction(1, 12);
    }
  }, [allMerchantProduct]);

  const handleSignUp = (values) => {
    try {
      dispatch(reSignInLoading());
      signUpUser({
        variables: {
          data: {
            ...values,
            merchant_rewards_id: `${values.merchant_rewards_id}` || "",
            sex: "-",
          },
        },
      });
    } catch (error) {
      message.error(error.message);
    }
  };

  useEffect(() => {
    const storageUser = localStorage.getItem("user_customer_details");
    const userd = storageUser && JSON.parse(storageUser);

    const activeMId = targetMerchantId || merchant_rewards_id || merchant_id;
    if (userd && activeMId) {
      const id = activeMId.toString();
      const values = {
        first_name: userd?.first_name,
        phone_number: userd?.phone_number,
        merchant_rewards_id: id,
      };
      if (userd.merchant_id === null || String(userd?.merchant_id) !== String(id)) {
        if (!merchantIdArray.includes(id)) {
          handleSignUp(values);
        }
      }
    }
  }, [merchantDetailsByIdData, merchantDetailsData, targetMerchantId, merchant_rewards_id]);

  const merchant = merchantDetails && merchantDetails.merchant_details;
  const activeLoyalty = merchantDetails?.allMultiLoyalties?.find(
    (loyalty) => (String(loyalty.status || loyalty.state || "").toLowerCase() === "active" || loyalty.active === true || loyalty.is_active === true) && !loyalty.deleted
  );
  if (activeLoyalty) {
    localStorage.setItem("active_loyalty", JSON.stringify(activeLoyalty));
  } else {
    localStorage.removeItem("active_loyalty");
  }

  //document.title = merchant?.busiFness_name || "uRewards Merchant";
  merchant &&
    localStorage.setItem("merchant_details", JSON.stringify(merchant));

  useEffect(() => {
    if (merchantsuccess === false) {
      merchant && dispatch(saveMerchantState(merchant));
    }
  }, [merchant]);

  useEffect(() => {
    if (!merchant?.id && !merchant?.email) {
      setIsServicesEnabled(false);
      return;
    }

    dispatch(getApp({ id: merchant.id, email: merchant.email }))
      .then((res) => {
        if (!isMountedRef.current) return;
        const application = res?.data?.data || [];
        const hasServices = isBookingAddonEnabled(application);
        setIsServicesEnabled(hasServices);

        const lower = (s) => (s || "").toString().toLowerCase().trim();
        const hasProductBundle = application.some((app) =>
          lower(app?.app?.app_name || app?.app_name || app?.name).includes("product bundle")
        );
        setIsProductBundleEnabled(hasProductBundle);
      })
      .catch((err) => {
        console.log("err fetching merchant apps", err);
        if (isMountedRef.current) {
          setIsServicesEnabled(false);
        }
      });
  }, [merchant?.id, merchant?.email]);

  useEffect(() => {
    if (showSearchIcon === true) {
      inputRef.current.focus();
    }
  }, [showSearchIcon]);

  useEffect(() => {
    let catNames = [];
    productCategory.length > 0 &&
      productCategory.map((cat, index) => {
        catNames.push(cat.id);
      });
    setCatName(catNames);
  }, [productCategory]);
  
  const handleSelectChange = (value) => {
    setSelectedBranchId(value);
    setIsBranchSelected(true);
    const selectedBranch = merchantBranches.filter((branch) => {
      return branch.id === value;
    });

    // console.log("dfd", selectedBranch);
    setSelectedBranchDetails(selectedBranch[0]);

    // Clear previous products when switching branches
    setAllMerchantProduct([]);
    setMerchantProduct([]);
    setMerchantProductFilter([]);
    setTotalProductNum(0);

    const branchpayload = {
      isbranchSet: true,
      address_line1: selectedBranch[0].address_line1,
      address_line2: selectedBranch[0].address_line2,
      branch_id: selectedBranch[0].id,
      branch_name: selectedBranch[0].name,
      latitude: selectedBranch[0].latitude,
      longitude: selectedBranch[0].longitude,
      state: selectedBranch[0].state,
    };

    localStorage.setItem("branchdetails", JSON.stringify(branchpayload));
    dispatch(setBranchAddress(branchpayload));
    dispatch(clearCart());
    setShowBranchSelect(false);
  };

  const handleProductSearch = (value) => {
    const merchant_email = merchantDetails?.merchant_details.email;
    setProductsLoading(true);

    const productToFind = allMerchantProduct.filter((prod) => {
      return prod.name.toLowerCase().includes(value.toLowerCase());
    });

    const pageSize = currrentPageNumber || 12;

    if (productToFind.length < 1) {
      Axios.post(
        `${process.env.REACT_APP_MULTI_LEVEL_BASE_URL}/search_products_name`,
        { value, merchant_email, id: merchantDetails?.merchant_details.id }
      )
        .then((res) => {
          if (!isMountedRef.current) return;
          if (res.status === 200 && res.data?.data) {
            setProductsLoading(false);
            const foundData = res.data.data;
            setMerchantProduct(foundData.slice(0, pageSize));
            setMerchantProductFilter(foundData);
            setTotalProductNum(foundData.length);
          } else {
            setMerchantProduct(merchantProductFilter.slice(0, pageSize));
            setTotalProductNum(merchantProductFilter.length);
          }
        })
        .catch((err) => {
          if (!isMountedRef.current) return;
          setProductsLoading(false);
          setMerchantProduct(merchantProductFilter.slice(0, pageSize));
          setTotalProductNum(merchantProductFilter.length);
          message.error(
            `unable to process request, ${err.response?.statusText || err.message}`
          );
        });
    } else {
      setProductsLoading(false);
      setMerchantProduct(productToFind.slice(0, pageSize));
      setMerchantProductFilter(productToFind);
      setTotalProductNum(productToFind.length);
    }
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
    setCurrentPage(1);
    const pageSize = currrentPageNumber || 12;

    if (key === "All") {
      if (allMerchantProduct && allMerchantProduct.length > 0) {
        setMerchantProduct(allMerchantProduct.slice(0, pageSize));
        setMerchantProductFilter(allMerchantProduct);
        setTotalProductNum(allMerchantProduct.length);
      } else {
        setMerchantProduct(merchantProductFilter);
        getMerchantProduction(1, pageSize);
      }
    } else if (key === "Bundles") {
      const bundles = bundledProduct || [];
      setMerchantProduct(bundles.slice(0, pageSize));
      setMerchantProductFilter(bundles);
      setTotalProductNum(bundles.length);
    } else {
      const catId = catName[key];
      const categoryProducts = (allMerchantProduct || []).filter((prod) => {
        return prod.merchant_product_category_id === catId;
      });
      setMerchantProduct(categoryProducts.slice(0, pageSize));
      setMerchantProductFilter(categoryProducts);
      setTotalProductNum(categoryProducts.length);
    }

    const element = document.getElementById("tabdds") || document.getElementById("product_list") || document.getElementById("items_products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handlePageChange = (page, pageSize) => {
    const size = pageSize || currrentPageNumber || 12;
    setCurrentPage(page);
    if (pageSize && pageSize !== currrentPageNumber) {
      setCurrentPageNumber(pageSize);
    }

    if (allMerchantProduct && allMerchantProduct.length > 0 && merchantProductFilter && merchantProductFilter.length > 0) {
      const startIndex = (page - 1) * size;
      const endIndex = startIndex + size;
      setMerchantProduct(merchantProductFilter.slice(startIndex, endIndex));
    } else {
      getMerchantProduction(page, size);
    }

    const element = document.getElementById("tabdds") || document.getElementById("product_list") || document.getElementById("items_products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const itemD = () => {
    let cate = isProductBundleEnabled ? [
      {
        key: "All",
        label: "All",
      },
      {
        key: "Bundles",
        label: "Bundles"
      }
    ] : [ {
      key: "All",
      label: "All",
    }];
    let catNames = [];
    productCategory.length > 0 &&
      productCategory.map((cat, index) => {
        if (cat.deleted) {
          return;
        } else {
          const newCat = {
            key: index,
            label: cat.name,
            children: <>{}</>,
          };
          catNames.push(cat.name);
          cate.push(newCat);
        }
      });

    // setCatName(catNames)
    return cate;
  };

  const calculateLowestAndHighestPrice = (item) => {
    const sortedItems = item.sort((a, b)=> {
      return Number(a.price) - Number(b.price)
    });

    const lowestPrice = sortedItems[0];
    const highestPrice = sortedItems[sortedItems.length - 1];

    if(Number(lowestPrice.price) === Number(highestPrice.price)){
      return <span>{Number(highestPrice.price).toFixed(2)}</span> 
    }else{
      return <span>{Number(lowestPrice.price).toFixed(2)} - {Number(highestPrice.price).toFixed(2)}</span>
    }
  }

  const items = productCategory.length > 0 && itemD();

  // const customer_loyalty_programs = newUser?.loyalty_points
  //   ? [
  //       ...newUser?.loyalty_points.simple_points,
  //       ...newUser?.loyalty_points.stamps_program,
  //     ]
  //   : [];

  if (
    !merchantDetailsLoading &&
    merchantDetailsData?.fetchMerchantDetails === "Merchant not found"
  ) {
    return <Redirect to="404" />;
  }
  if (
    !merchantDetailsByIdLoading &&
    merchantDetailsByIdData?.fetchMerchantById === "Merchant not found"
  ) {
    return <Redirect to="404" />;
  }
  

  if (!!redirect) return <Redirect to={redirect} />;
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={
            merchant?.description ||
            `Browse products and Services from ${merchant?.business_name}, make a purchase and earn rewards 🎁`
          }
        />
        <meta property="title" content={merchant?.business_name} />

        <meta
          name="keywords"
          content={merchant?.business_name || merchant?.description}
        />
        <link rel="shortcut icon" id="favicon" href={merchant?.image || merchant?.cover_image || LogoBlack} />
        <link rel="icon" id="icon-fav" href={merchant?.image || merchant?.cover_image || LogoBlack} />
        <title>{merchant?.business_name}</title>
        <meta property="og:title" content={merchant?.business_name} />
        <meta
          property="og:description"
          content={
            merchant?.description ||
            `Browse products and Services from ${merchant?.business_name}, make a purchase and earn rewards 🎁`
          }
        />
        <meta
          property="og:image"
          itemprop="image"
          content={merchant?.image || merchant?.cover_image || JayAutos}
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={merchant?.business_name} />
        <meta
          name="twitter:description"
          content={
            merchant?.description ||
            `Browse products and Services from ${merchant?.business_name}, make a purchase and earn rewards 🎁`
          }
        />
        <meta
          name="twitter:image"
          content={merchant?.image || merchant?.cover_image || JayAutos}
        />
      </Helmet>
      <VariantModal
        open={openVariantModal}
        onCancel={() => setOpenVariantModal(false)}
        product={productVariantModal}
      />
      <CustomQuantityModal 
        open={openCustQuantity}
        onCancel={()=>{
          setOpenCustQuantity(false);
        }}
        product={productCustomQuantityModal}
        merchant={merchant}
      />
      {signInModalVisible && (
        <SigninModal
          visible={signInModalVisible}
          merchant_rewards_id={merchant_rewards_id}
          onCancel={() => setSignInModalVisible(false)}
          setNewUser={setNewUser}
          merchant={merchant}
          checkInAgain={checkInAgain}
          setConfirmGiftCard={() => {
            setConfirmGiftCard(true);
          }}
          setCustomerLoyaltyProgram={setCustomerLoyaltyProgram}
        />
      )}
      {showWalletModal && newUser && (
        <Modal
          visible={showWalletModal}
          onCancel={() => setShowWalletModal(false)}
          footer={null}
          centered
          width={420}
        >
          {(() => {
            const rawParsed = typeof merchantDetailsData?.fetchMerchantDetails === 'string'
              ? JSON.parse(merchantDetailsData.fetchMerchantDetails)
              : (merchantDetailsData?.fetchMerchantDetails || (merchantDetailsByIdData?.fetchMerchantById && JSON.parse(merchantDetailsByIdData.fetchMerchantById)) || {});

            const isCurrentDetails = rawParsed && (
              (targetMerchantId && String(rawParsed?.merchant_details?.id) === String(targetMerchantId)) ||
              (merchant_rewards_id && (
                String(rawParsed?.merchant_details?.uRewardsId || '').toLowerCase() === String(merchant_rewards_id).toLowerCase() ||
                String(rawParsed?.merchant_details?.id) === String(merchant_rewards_id)
              ))
            );

            const parsedDetails = isCurrentDetails ? rawParsed : {};
            const merchantObj = parsedDetails?.merchant_details || (isCurrentDetails ? merchant : null);
            const bizName = merchantObj?.business_name || merchantObj?.name || passMerchantName || (!isNumericMerchantId ? merchant_rewards_id : '') || 'Loystar Merchant';
            const logoUrl = merchantObj?.logo || merchantObj?.logo_url || merchantObj?.image || merchantObj?.display_picture_url || merchantObj?.cover_image || parsedDetails?.merchant_details?.logo || parsedDetails?.merchant_details?.image || passLogoUrl || '';
            const customerName = newUser?.first_name || 'Valued Guest';
            const merchantIdVal = targetMerchantId || merchantObj?.id || merchant_rewards_id || '37';

            // Strictly require a genuine 13-digit membership code.
            // Card Kit is infrastructure — it trusts whatever we pass.
            // We must NEVER pass a short DB id (e.g. "1") as loyalty_id.
            const rawLoyaltyId = newUser?.loyalty_id || newUser?.loyaltyId || newUser?.loyalty_code;
            const hasValidLoyaltyId = rawLoyaltyId && String(rawLoyaltyId).length >= 8 && !String(rawLoyaltyId).startsWith('LOY-');
            const validLoyaltyCode = hasValidLoyaltyId ? String(rawLoyaltyId) : '';
            const customerIdVal = validLoyaltyCode || newUser?.id || newUser?.customer_id || newUser?.phone_number || 'guest';
            
            const rawLoyalties = parsedDetails?.allMultiLoyalties 
              || parsedDetails?.all_multi_loyalties 
              || parsedDetails?.merchant_details?.loystar_programs 
              || parsedDetails?.merchant_details?.loyalties 
              || parsedDetails?.loyalties 
              || parsedDetails?.programs 
              || [];

            const activeLoyalties = (Array.isArray(rawLoyalties) ? rawLoyalties : []).filter(
              (l) => l && (l.status === true || l.status === "1" || String(l.status).toLowerCase() === "active" || l.is_active === true || l.active === true) && !l.deleted
            );
            const mtierLoyalties = activeLoyalties;

            // Normalize simple points, stamps, and instant discount programs from merchantLoyaltyProgram state
            const simpleAndStampsPrograms = (isCurrentDetails && Array.isArray(merchantLoyaltyProgram) ? merchantLoyaltyProgram : []).filter(
              (p) => p && (p.active === true || p.active === 1 || p.active === "1" || p.status === true || p.status === "1" || String(p.status).toLowerCase() === "active") && !p.deleted
            ).map((p) => {
              const pType = p.program_type === "StampsProgram" ? "Stamp" 
                : (p.program_type === "SimplePoints" ? "Points" 
                : (p.program_type === "InstantDiscount" ? "Discount Card (Instant)" : (p.program_type || "Points")));
              
              const benefits = p.reward 
                ? (p.threshold ? `Earn ${p.threshold} to redeem ${p.reward}` : p.reward) 
                : 'Earn points & redeem rewards';

              const target = p.threshold 
                ? (pType === 'Stamp' ? `${p.threshold} Stamps` : `${p.threshold} Points`) 
                : (pType === 'Stamp' ? '10 Stamps' : '100 Points');

              return {
                id: p.id || p.merchant_loyalty_program_id || p.name,
                title: p.name || `${pType} Program`,
                name: p.name || `${pType} Program`,
                program_type: pType,
                type: pType,
                description: benefits,
                benefits: benefits,
                target: target,
                target_points: target
              };
            });

            const multiTierPrograms = (isCurrentDetails ? mtierLoyalties : []).map((p) => {
              const pType = p.program_type || p.type || 'Membership (Multi-tier)';
              return {
                ...p,
                title: p.title || p.name || `${pType} Program`,
                program_type: pType,
                type: pType
              };
            });

            // If a specific program was scanned / passed via URL, build its fallback descriptor
            const urlProgram = (passProgramId || passProgramName) ? {
              id: passProgramId || '15',
              title: passProgramName || `Loyalty Program ${passProgramId || '15'}`,
              name: passProgramName || `Loyalty Program ${passProgramId || '15'}`,
              program_type: passProgramName.toLowerCase().includes('stamp') ? 'Stamp' : (passProgramName.toLowerCase().includes('discount') ? 'Discount Card (Instant)' : 'Points'),
              type: passProgramName.toLowerCase().includes('stamp') ? 'Stamp' : (passProgramName.toLowerCase().includes('discount') ? 'Discount Card (Instant)' : 'Points'),
              description: 'Earn points & redeem rewards',
              benefits: 'Earn points & redeem rewards',
              target: passProgramName.toLowerCase().includes('stamp') ? '10 Stamps' : '100 Points',
              target_points: passProgramName.toLowerCase().includes('stamp') ? '10 Stamps' : '100 Points'
            } : null;

            // Combine all programs, giving priority to real API programs over URL fallback
            const allCombinedPrograms = [];
            const seenProgramIds = new Set();

            [...simpleAndStampsPrograms, ...multiTierPrograms].forEach((prog) => {
              const pKey = String(prog.id);
              if (!seenProgramIds.has(pKey)) {
                seenProgramIds.add(pKey);
                allCombinedPrograms.push(prog);
              }
            });

            if (urlProgram && !seenProgramIds.has(String(urlProgram.id))) {
              seenProgramIds.add(String(urlProgram.id));
              allCombinedPrograms.push(urlProgram);
            }

            const currentProgram = allCombinedPrograms.find((p) => String(p.id) === String(selectedProgramId || passProgramId)) || allCombinedPrograms[0] || urlProgram;
            const currentProgramId = currentProgram?.id || selectedProgramId || passProgramId || '15';

            const passSerial = `LOY-${merchantIdVal}-${currentProgramId}-${customerIdVal}`;
            const cardKitBase = process.env.REACT_APP_CARD_KIT_URL || 'https://cardkit.loystar.co';
            
            const cardTypeVal = currentProgram?.program_type || currentProgram?.type || (passProgramName.toLowerCase().includes('stamp') ? 'Stamp' : 'Points');
            const programNameVal = (currentProgram?.title && !currentProgram.title.startsWith('Loyalty Program ')) 
              ? currentProgram.title 
              : (currentProgram?.name && !currentProgram.name.startsWith('Loyalty Program '))
                ? currentProgram.name
                : passProgramName || `${bizName} Loyalty Card`;
            const rewardBenefitsVal = currentProgram?.description || currentProgram?.benefits || 'Earn points & redeem rewards';
            const targetRequiredVal = currentProgram?.target || currentProgram?.target_points || currentProgram?.stamps_needed || (cardTypeVal === 'Stamp' ? '10 Stamps' : '100 Points');
            const currentBalanceVal = (isCurrentDetails && (newUser?.total_points || newUser?.total_stamps)) ? `${newUser?.total_points || newUser?.total_stamps} ${cardTypeVal === 'Stamp' ? 'Stamps' : 'Pts'}` : (cardTypeVal === 'Stamp' ? '0 Stamps' : '0 Pts');
            const heroImageUrlVal = merchantObj?.display_picture_url || merchantObj?.banner_url || logoUrl || passHeroImageUrl || '';

            const walletPassUrl = `${cardKitBase}/v1/passes/smart/${passSerial}?name=${encodeURIComponent(customerName)}&merchant_name=${encodeURIComponent(bizName)}&logo_url=${encodeURIComponent(logoUrl)}&customer_id=${encodeURIComponent(customerIdVal)}&loyalty_id=${encodeURIComponent(validLoyaltyCode || customerIdVal)}&phone=${encodeURIComponent(newUser?.phone_number || '')}&program_name=${encodeURIComponent(programNameVal)}&card_type=${encodeURIComponent(cardTypeVal)}&reward_benefits=${encodeURIComponent(rewardBenefitsVal)}&target_required=${encodeURIComponent(targetRequiredVal)}&current_balance=${encodeURIComponent(currentBalanceVal)}&hero_image_url=${encodeURIComponent(heroImageUrlVal)}`;

            // Do not render wallet buttons until the loyalty_id async lookup has
            // completed. This prevents a stale/fallback ID from being baked into
            // the pass barcode and serial number.
            if (!loyaltyIdResolved) {
              return (
                <div style={{ textAlign: "center", padding: "40px 10px" }}>
                  <Spin size="large" />
                  <p style={{ color: "#6B7280", marginTop: "16px", fontSize: "0.9rem" }}>
                    Loading your loyalty card&hellip;
                  </p>
                </div>
              );
            }

            return (
              <div style={{ textAlign: "center", padding: "20px 10px" }}>
                {logoUrl && (
                  <img
                    src={logoUrl}
                    alt={bizName}
                    style={{ height: "48px", marginBottom: "12px", objectFit: "contain" }}
                  />
                )}
                <h2 style={{ fontSize: "1.4rem", fontWeight: "bold", marginBottom: "8px", color: "#111827" }}>
                  Save Your {bizName} Loyalty Card
                </h2>
                
                {allCombinedPrograms.length > 1 && (
                  <div style={{ marginBottom: "18px", textAlign: "left" }}>
                    <label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#374151", marginBottom: "6px", display: "block" }}>
                      Select Loyalty Program:
                    </label>
                    <Select
                      style={{ width: "100%" }}
                      value={String(currentProgramId)}
                      onChange={(val) => setSelectedProgramId(val)}
                      size="large"
                    >
                      {allCombinedPrograms.map((prog) => {
                        const pTitle = prog.title || prog.name || prog.program_name || `${prog.program_type || 'Loyalty'} Program`;
                        const pType = prog.program_type || prog.type || 'Points';
                        return (
                          <Select.Option key={prog.id} value={String(prog.id)}>
                            {pTitle} ({pType})
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </div>
                )}

                <p style={{ color: "#6B7280", marginBottom: "20px" }}>
                  Welcome {customerName}! Tap below to save your <b>{programNameVal}</b> card to your mobile wallet.
                </p>
                <a
                  href={walletPassUrl}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "14px 20px",
                    backgroundColor: "#000000",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    fontWeight: "600",
                    textDecoration: "none",
                    marginBottom: "14px",
                    fontSize: "1rem"
                  }}
                >
                   Add to Apple Wallet
                </a>
                <a
                  href={walletPassUrl}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "14px 20px",
                    backgroundColor: "#4285F4",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    fontWeight: "600",
                    textDecoration: "none",
                    fontSize: "1rem"
                  }}
                >
                  Save to Google Wallet
                </a>
              </div>
            );
          })()}
        </Modal>
      )}
      {openPriceFilter && (
        <PriceFilter 
          open={openPriceFilter}
          onCancel={() => setOpenPriceFilter(false)}
          minPrice={minPrice}
          maxPrice={maxPrice}
          currentMinPrice={currentMinPrice}
          currentMaxPrice={currentMaxPrice}
          selectedVariants={selectedVariants}
          availableVariants={getAvailableVariants(allMerchantProduct)}
          onChange={(value)=>{
            onSlidderChange(value[0], value[1])
          }}
          onVariantChange={onVariantChange}
          onClick={handleApplyPriceFilter}
          user={merchant}
          resetFilter={() => resetFilter()}
        />
      )}
      <GiftModal
        open={confirmGiftCard}
        onCancel={() => setConfirmGiftCard(false)}
        setNewUser={setNewUser}
        checkInAgain={checkInAgain}
      />
      <BranchModal
        open={openBranchModal}
        onCancel={() => setOpenBranchModal(false)}
        branches={merchantBranches}
        businessName={merchant?.business_name}
        setSelectedBranchId={setSelectedBranchId}
        selectedBranchId={selectedBranchId}
        setIsBranchSelected={setIsBranchSelected}
        setSelectedBranchDetails={setSelectedBranchDetails}
        merchant={merchantDetails}
      />
      {checkDescription && (
        <Modal
          open={checkDescription}
          onCancel={() => setCheckDescription(false)}
          className="description_modal"
          // onOk={}
          title={
            <p
              style={{
                fontSize: "24px",
                lineHeight: "23px",
                color: "#000",
                textAlign: "center",
                marginBottom: "-0.1rem",
              }}
            >
              <b>{description.name}</b>
            </p>
          }
          footer={[
            <div
              key="modal-footer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              {/* Price */}
              <p
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#000",
                }}
              >
                {merchant?.currency}
                {Number(description.price).toFixed(2)}
              </p>

              {/* Add to cart */}
              <button
                type="button"
                className="ls-modal-add-btn"
                aria-label="Add to cart"
                onClick={() => {
                  if (description.variants && description.variants.length > 0) {
                    handleOpenVariant(description);
                    setCheckDescription(false);
                  } else if (description.custom_quantities && description.custom_quantities.length > 0) {
                    handleSelectCustomQuantity(description);
                    setCheckDescription(false);
                  } else {
                    addProductToCart(description, 1, description.quantity);
                    setCheckDescription(false);
                  }
                }}
              >
                <HiPlus />
                <span>{description.variants?.length > 0 ? "Choose options" : "Add to cart"}</span>
              </button>
            </div>,
          ]}
        >
          <div className="div_body">
            {/* <div className="div_img"> */}
            {description.extra_pictures.length > 0 ? (
              <Carousel autoplay autoplaySpeed={4000} dots={true} style={{minWidth: "300px", minHeight: "300px"}}>
               {description.extra_pictures.map((pictures, index) => {
                return (
                <div key={index} style={{height:300}}>
                  <div style={{height: 300}}>
                  <Image
                    src={pictures}
                    alt={pictures}
                    style={{
                      // height: "300px",
                      // width: "auto",
                      // objectFit: "cover",
                      // maxHeight: "300px",
                      // maxWidth: "300px",
                    }}
                  />
                  </div>
                </div>
                ) 
                })}
                <Image
                    src={description.picture}
                    alt={description.name}
                    style={{
                      // height: "300px",
                      // width: "auto",
                      // objectFit: "cover",
                      // maxHeight: "300px",
                      // maxWidth: "300px",
                    }}
                />
            </Carousel>     
            ) : description.picture ? (
              <img
                src={description.picture}
                alt={description.name}
                style={{
                  height: "auto",
                  width: "auto",
                  objectFit: "cover",
                  maxHeight: "300px",
                  maxWidth: "300px",
                }}
              />
            ) : (
              <div
                style={{
                  width: "240px",
                  height: "240px",
                  maxWidth: "100%",
                  margin: "0 auto 12px auto",
                  borderRadius: "16px",
                  overflow: "hidden",
                }}
              >
                <LetterAvatar name={description.name} fontSize={72} />
              </div>
            )}
            <p
              style={{
                fontSize: "14px",
                lineHeight: "16px",
                padding: "0.5rem 2rem 0",
                marginBottom: 0,
              }}
            >
              {
                description.products 
                  && description.products.length > 0 
                  && description.products.map((pro, index)=>{
                    return <div style={{marginBottom: 0}} key={index}><b>{pro.name}</b> - {description.quantity[index]} (units)</div>
                  })
              }
              {description.description}
            </p>
            <div>{displayVariants(description)}</div>
          </div>
        </Modal>
      )}
      {askCart && (
        <Modal
          open={askCart}
          onCancel={() => setAskCart(false)}
          className="sure_modal"
          onOk={() => handleCancelOrder()}
          footer={[
            <div>
              <Button onClick={() => handleCancelOrder()}>Yes</Button>
              <Button onClick={() => setAskCart(false)}>No</Button>
            </div>,
          ]}
        >
          {/* <div> */}
          <h4>
            Item(s) in cart have not been checkedout from previous merchant, do
            you want to cancel order?
          </h4>
          {/* </div> */}
        </Modal>
      )}
      <Modal
        open={displayVariant}
        onCancel={() => {
          setQuantity(1);
          setVariantQuantity(null);
          setDisplayVariant(false);
        }}
        title={productWithVariant?.name}
        className="variants"
        footer={[
          <Button key="cancel">Cancel</Button>,
          <Button key="submit">Add to cart</Button>,
        ]}
      >
        <div className="variants">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>Variants:</span>
            <Button
              type="btn-primary"
              onClick={() => {
                setQuantity(1);
                setVariantQuantity(null);
              }}
            >
              Clear variants
            </Button>
          </div>
          <div>
            {productWithVariant?.variants?.map((item, index) => {
              return (
                <div key={index}>
                  <span style={{ fontSize: "14px" }} key={index}>{item?.type}</span>
                  <div
                    style={{ margin: "1rem 0" }}
                    onClick={() => handleVariantChoice(item)}
                    key={index}
                  >
                    <span className="item_variant">
                      <span>{item.value}</span>
                      <span> - </span>
                      <span>
                        {merchant?.currency} {item.price}
                        <sup>{item.quantity}</sup>
                      </span>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <div>
            <span style={{ fontSize: "13px" }}>Quantity:</span>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "10% 80% 10%",
                textAlign: "center",
                fontSize: "12px",
              }}
            >
              <span
                className="btn_change"
                onClick={() => handleVariantRemove()}
              >
                -
              </span>
              <span>{quantity}</span>
              <span className="btn_change" onClick={() => handleVariantAdd()}>
                +
              </span>
            </div>
          </div>
        </div>
      </Modal>
      <div style={{ position: "relative" }}>
        <Header
          openLoginModal={() => setSignInModalVisible(true)}
          titleComponent={
            <h2 className="title_text" style={{ margin: 0 }}>
              {merchant?.business_name || "Merchant"}
            </h2>
          }
          merchantLink={merchant_rewards_id}
          merchantee
          merchantBranches={merchantBranches}
          selectedBranchDetails={selectedBranchDetails}
          onBranchSelect={handleSelectChange}
          selectedBranchId={selectedBranchId}
        />
        <MerchantTabs
          merchantSlug={merchant_rewards_id}
          activeKey="shop"
          hasServices={isServicesEnabled}
        />
      </div>
      <div className="container_main">
        <Card
          bordered={false}
          bodyStyle={{ padding: 0 }}
          loading={merchantDetailsLoading || merchantDetailsByIdLoading}
          style={{ backgroundColor: "transparent", border: "none" }}
        >
          {(() => {
            const openPass = (programId) => {
              if (programId !== undefined && programId !== null) {
                setSelectedProgramId(String(programId));
              }
              const storageUser = localStorage.getItem("user_customer_details");
              if (storageUser || newUser) {
                setShowWalletModal(true);
              } else {
                setSignInModalVisible(true);
              }
            };
            const locationParts = [];
            if (selectedBranchDetails) {
              if (selectedBranchDetails.address_line1) locationParts.push(selectedBranchDetails.address_line1);
              if (selectedBranchDetails.address_line2) locationParts.push(selectedBranchDetails.address_line2);
            } else {
              const a1 = merchant?.address_line1?.trim();
              const a2 = merchant?.address_line2?.trim();
              if (a1 && a1 !== "-") locationParts.push(a1);
              if (a2 && a2 !== "-") locationParts.push(a2);
              if (merchant?.state) locationParts.push(merchant.state);
              if (merchant?.country) locationParts.push(merchant.country);
            }
            const rewardCount = merchantLoyaltyProgram.length + (activeLoyalty ? 1 : 0);
            const shareStore = () => {
              const url = window.location.href;
              const title = merchant?.business_name || "Store";
              const text = merchant?.description || `Shop and earn rewards at ${title}`;
              if (navigator.share) {
                navigator.share({ title, text, url }).catch(() => {});
              } else if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(() => message.success("Store link copied"));
              }
            };
            const programCopy = (program) => {
              if (program?.program_type === "StampsProgram") {
                return `You have ${getCustomerPoint(program.name)} stamps · collect ${program?.threshold != null ? Math.floor(Number(program.threshold)) : ""} to redeem`;
              }
              if (program?.program_type === "SimplePoints") {
                return `You have ${getCustomerPoint(program.name)} pts · earn ${program?.threshold != null ? Math.floor(Number(program.threshold)) : ""} to redeem`;
              }
              return null;
            };
            const programProgress = (program) => {
              const have = Number(getCustomerPoint(program.name)) || 0;
              const need = Number(program?.threshold) || 0;
              if (!need) return null;
              return Math.max(4, Math.min(100, (have / need) * 100));
            };
            const typeLabel = (t) =>
              t === "StampsProgram" ? "Stamps" : t === "SimplePoints" ? "Points" : t === "InstantRewards" ? "Instant" : t === "CashRewards" ? "Cash reward" : "Rewards";

            return (
              <>
                <section className="lss-hero ls-fade-up">
                  <div
                    className={`lss-hero__cover${merchant?.cover_image ? "" : " lss-hero__cover--empty"}`}
                    style={merchant?.cover_image ? { backgroundImage: `url(${merchant.cover_image})` } : undefined}
                  >
                    {!merchant?.cover_image && (
                      <span className="lss-hero__cover-word">{merchant?.business_name}</span>
                    )}
                  </div>

                  <div className="lss-hero__row">
                    <div className="lss-hero__identity">
                      {merchant?.image ? (
                        <img
                          className="lss-hero__logo"
                          src={merchant.image}
                          alt={`${merchant?.business_name || "Merchant"} logo`}
                        />
                      ) : (
                        <div className="lss-hero__logo lss-hero__logo--initial">
                          {(merchant?.business_name || "S").charAt(0).toUpperCase()}
                        </div>
                      )}
                      <div className="lss-hero__info">
                        <h1 className="lss-hero__name">{merchant?.business_name}</h1>
                      </div>
                    </div>

                    <div className="lss-hero__actions">
                      <Button
                        type="primary"
                        size="large"
                        id="add-wallet-pass-button"
                        onClick={() => openPass()}
                      >
                        Join rewards
                      </Button>
                      <Button size="large" id="start-order-button">
                        <a
                          href={
                            merchantProduct.length !== 0
                              ? "#items_products"
                              : undefined
                          }
                        >
                          {carts && carts.length === 0 ? "Start Order" : "View Items"}
                        </a>
                      </Button>
                      <button
                        type="button"
                        className="lss-round-btn"
                        id="share-store-button"
                        aria-label="Share store"
                        onClick={shareStore}
                      >
                        <HiArrowUpOnSquare />
                      </button>
                    </div>
                  </div>

                  {merchant?.description && (
                    <p className="lss-hero__desc">{merchant?.description}</p>
                  )}
                </section>

                {rewardCount > 0 && (
                  <section className="lss-section" id="store_rewards">
                    <div className="lss-section__head">
                      <div>
                        <h2 className="lss-section__title">Rewards at {merchant?.business_name}</h2>
                        <p className="lss-section__sub">Earn on every purchase. Save your pass to track progress.</p>
                      </div>
                    </div>
                    <div className="lss-rail">
                      {activeLoyalty && (
                        <button
                          type="button"
                          className="lss-reward-card"
                          onClick={() => openPass()}
                        >
                          <div
                            className="lss-reward-card__media"
                            style={activeLoyalty?.image_url ? { backgroundImage: `url(${activeLoyalty.image_url})` } : undefined}
                          >
                            {!activeLoyalty?.image_url && <HiGift />}
                            <span className="lss-chip">Points</span>
                          </div>
                          <div className="lss-reward-card__body">
                            <p className="lss-reward-card__name">{activeLoyalty?.name}</p>
                            <p className="lss-reward-card__desc">
                              Earn {activeLoyalty?.points != null ? Math.floor(Number(activeLoyalty.points)) : ""} pts for every {merchantDetails?.merchant_details?.currency}
                              {activeLoyalty?.currency_value} spent
                            </p>
                            <p className="lss-reward-card__balance">
                              {totalCustomerPoints
                                ? Math.floor(Number(totalCustomerPoints)) + " pts"
                                : "0 pts"}
                            </p>
                          </div>
                        </button>
                      )}
                      {merchantLoyaltyProgram.map((program, index) => {
                        const pct = programProgress(program);
                        const img = program?.images && program.images.length > 0 ? program.images[0] : null;
                        return (
                          <button
                            type="button"
                            key={program?.id || index}
                            className="lss-reward-card"
                            onClick={() => openPass(program?.id)}
                          >
                            <div
                              className="lss-reward-card__media"
                              style={img ? { backgroundImage: `url(${img})` } : undefined}
                            >
                              {!img && <HiGift />}
                              <span className="lss-chip">{typeLabel(program?.program_type)}</span>
                            </div>
                            <div className="lss-reward-card__body">
                              <p className="lss-reward-card__name">{program?.name}</p>
                              {program?.reward && (
                                <p className="lss-reward-card__desc">Reward: {program.reward}</p>
                              )}
                              {programCopy(program) && (
                                <p className="lss-reward-card__progress-text">{programCopy(program)}</p>
                              )}
                              {pct !== null && (
                                <div className="lss-progress"><span style={{ width: `${pct}%` }} /></div>
                              )}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </section>
                )}
              </>
            );
          })()}
          <div className="multi_loyalty">
            <>
              <div className="display_credit">
                {isServicesEnabled && (
                  <div
                    className="booking"
                    // style={{
                    //   border: "1px solid white",
                    //   height: "100%",
                    //   display: "flex",
                    //   flexDirection: "column",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    // }}
                  >
                    <h2>Service booking</h2>
                    <p>click here to book a service</p>
                    <div className="bookingbtn">
                      <Button
                        type="primary"
                        // style={{
                        //   padding: "5% 1rem 2rem",
                        //   backgroundColor: "#fff",
                        //   color: "#000",
                        // }}
                        onClick={() => {
                          // setServiceBooking(!serviceBooking)
                          // <Redirect to={`${}`} />
                          history.push({
                            pathname: `${history.location.pathname}/bookings`,
                            state: {
                              selectedBranchDetails: selectedBranchDetails
                            }
                          })
                        }}
                      >
                        Book Now
                      </Button>
                    </div>
                  </div>
                )}
              </div> 
            </>

             <Modal
              open={serviceBooking}
              onCancel={() => {
                setServiceBooking(!serviceBooking);
              }}
              title="Customer booking"
              className="variants"
              footer={null}
            >
              <Booking />
            </Modal> 
          </div>

          {/* {customer_loyalty_programs.length > 0 && (
            <div>
              <h3 className="title_text" style={{ marginTop: 30 }}>
                Loyalty Programs
              </h3>
              <Row>
                {customer_loyalty_programs.map((program, index) => (
                  <Col span={24} md={12} lg={8} key={index}>
                    <div
                      className="flex_center_column"
                      style={{
                        background:
                          "linear-gradient(180deg, #C4C4C4 0%, rgba(196, 196, 196, 0) 100%)",
                        height: "280px",
                        margin: "20px 10px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          padding: 20,
                          width: "100%",
                        }}
                      >
                        <img src={LoveIcon} alt="favourite" />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "100px",
                          width: "100%",
                          padding: "20px",
                        }}
                      >
                        <p style={{ float: "left", color: "#fff" }}>
                          <b>
                            {program.program_name}: {program.accumulated_points}
                          </b>
                        </p>
                        <p
                          style={{
                            float: "right",
                            color: "#fff",
                            textAlign: "right",
                          }}
                        >
                          <Button type="primary">
                            <b>Get</b>
                          </Button>
                        </p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )} */}
          {/* <hr style={{width: "100%"}}/> */}

          <div className="ls-products-head">
            <div>
              <h2
                className="lss-section__title"
                id="items_products"
              >
                Shop all
              </h2>
              {totalProductNum > 0 && (
                <p className="lss-section__sub">{totalProductNum} product{totalProductNum === 1 ? "" : "s"}</p>
              )}
            </div>
            <div className="ls-products-head__tools">
              <button
                type="button"
                className={`ls-filter-trigger${(Object.keys(selectedVariants).length > 0 || currentMinPrice !== minPrice || currentMaxPrice !== maxPrice) ? " is-active" : ""}`}
                id="product-filter-button"
                aria-label="Filter products"
                onClick={() => setOpenPriceFilter(true)}
              >
                <SlidersOutlined />
                <span>Filters</span>
                {(Object.keys(selectedVariants).length > 0 || currentMinPrice !== minPrice || currentMaxPrice !== maxPrice) && (
                  <span className="ls-filter-trigger__dot" />
                )}
              </button>
              <button
                type="button"
                className={`ls-icon-btn${showSearchIcon ? " is-active" : ""}`}
                id="product-search-button"
                aria-label="Search products"
                onClick={() => {
                  if (showSearchIcon && searchText) {
                    setSearchText("");
                    handleTabChange(activeKey);
                  }
                  setShowSearchIcon(!showSearchIcon);
                }}
              >
                <SearchOutlined />
              </button>
            </div>
          </div>
          {showSearchIcon ? (
            <Input
              value={searchText}
              placeholder="Search products"
              size="large"
              ref={inputRef}
              className="ls-search-input"
              prefix={<SearchOutlined style={{ color: "#9A9AA5" }} />}
              allowClear
              style={{ margin: "1rem 0" }}
              onChange={(e) => {
                const { value } = e.target;
                setSearchText(value);
                setCurrentPage(1);
                if (value === "") {
                  handleTabChange(activeKey);
                } else {
                  handleProductSearch(value);
                }
              }}
            />
          ) : (
            productCategory.length > 0 &&
             (
              <div id="tabdds">
                <Tabs
                  activeKey={activeKey}
                  onChange={handleTabChange}
                  items={items}
                ></Tabs>
              </div>
            )
          )}
          <div id="product_list">
            {productsLoading || merchantDetailsLoading || merchantDetailsByIdLoading || !merchantDetails?.merchant_details ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "48px 0",
                }}
              >
                <Spin
                  size="large"
                  // visible={true}
                  style={{ textAlign: "center", color: "#fff" }}
                  className="merchant_spin"
                />
              </div>
            ) : merchantProduct.length === 0 ? (
              <div className="ls-empty">
                <div className="ls-empty__icon">🛍️</div>
                <h3>No products found</h3>
                <p>Try a different category or search term.</p>
              </div>
            ) : (
              <Row gutter={[16, 28]} className="ls-product-grid">
                {merchantProduct.map((product, index) => {
                  const openDetails = () => {
                    setDescription(product);
                    setCheckDescription(true);
                  };
                  const priceLabel =
                    product.variants && product.variants.length > 0
                      ? calculateLowestAndHighestPrice(product.variants)
                      : product.custom_quantities && product.custom_quantities.length > 0
                      ? calculateLowestAndHighestPrice(product.custom_quantities)
                      : Number(product.price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  return (
                    <Col xs={12} sm={12} md={8} lg={6} key={index}>
                      <div className="ls-product-card" style={{ animationDelay: `${Math.min(index, 12) * 30}ms` }}>
                        <div
                          className="ls-product-card__media"
                          onClick={openDetails}
                          role="button"
                          tabIndex={0}
                          aria-label={`View ${product.name}`}
                        >
                          {product.picture ? (
                            <img
                              src={product.picture}
                              alt={product.name}
                              loading="lazy"
                            />
                          ) : (
                            <LetterAvatar
                              name={product.name}
                              fontSize={40}
                            />
                          )}
                          <button
                            type="button"
                            className="ls-product-card__add"
                            aria-label={`Add ${product.name} to cart`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (product.variants && product.variants.length > 0) {
                                const prod = {...product};
                                handleOpenVariant(prod);
                              } else if(product.custom_quantities && product.custom_quantities.length > 0){
                                handleSelectCustomQuantity(product);
                              }else {
                                const totalCount = typeof product.quantity === "object" ? 0 : product.quantity;
                                addProductToCart(product, 1, totalCount);
                              }
                            }}
                          >
                            <HiPlus />
                          </button>
                        </div>
                        <div className="ls-product-card__info" onClick={openDetails}>
                          <p className="ls-product-card__name">{product.name}</p>
                          <p className="ls-product-card__price">
                            {merchant?.currency}{" "}
                            {priceLabel}
                          </p>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
          </div>

          {totalProductNum > 0 && merchantProduct.length > 0 && !productsLoading && (
            <div className="ls-pagination-wrapper">
              <Pagination
                className="ls-pagination"
                total={totalProductNum}
                pageSize={currrentPageNumber}
                pageSizeOptions={[12, 24, 48, 100]}
                current={currentPage}
                responsive={true}
                showSizeChanger={totalProductNum > 12}
                showTotal={(total, range) => (
                  <span className="ls-pagination-total">
                    {range[0]}-{range[1]} of {total}
                  </span>
                )}
                onChange={(page, pageSize) => {
                  handlePageChange(page, pageSize);
                }}
              />
            </div>
          )}
        </Card>
      </div>
      <Footer active="discover" disable />
      <ToastContainer />
    </>
  );
}
const mapStateToProps = (state) => ({
  state: state,
  carts: state.carts,
  merchantDetails: state.merchantDetails,
  resignSuccess: state.resign,
  merchantIdArray: state.merchantIdArray,
  productState: state.productState,
  merchantState: state.merchantState,
  urewardsAuth: state.urewardsAuth,
});

export default connect(mapStateToProps)(MerchantsPage);
